import QDialog from './src/QDialog.js';

export default QDialog;
